export default __webpack_public_path__ + "static/media/icon_3_on.28d0bbc9.png";